import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"

import * as css from "./styles.css"

export type PanelFooterProps = PropsWithClassName<{}>

function PanelFooter({ className, children }: PanelFooterProps) {
  return <footer className={clsx(css.PanelFooter, className)}>{children}</footer>
}

export default PanelFooter
